// -*- js-indent-level: 4; -*-

import '../../../node_modules/tiny-slider/src/tiny-slider.scss';
import { tns } from 'tiny-slider/src/tiny-slider';

jQuery(document).ready(function(){
    const slider = tns({
        container: '#focussed-posts .carousel',
        axis: 'horizontal',
        controls: true,
        controlsText: [
            '<i class="icon-arrow-left"></i>',
            '<i class="icon-arrow-right"></i>'
        ],
        rewind: true,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
    });
});
